import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Accordion from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Accordion';
import AccordionSummary from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionSummary';
import AccordionDetails from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionDetails';

import Header from './Header';
import Body from './Body';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    borderRadius: theme.radius.md,
    '&:before': {
      display: 'none', // <--- Hides default boder bottom on open accordions
    },
  },
  header: {
    height: theme.spacing(5),
    padding: 0,
  },
  body: {},
  footer: {},
  accordion: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.radius.md,
    '& .MuiAccordion-root:before': {
      display: 'none',
    },
  },
  roundedAccordion: {
    borderRadius: theme.radius.md,
  },
  summary: {
    width: '100%',
  },
  accountDetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(1, 0, 0),
  },
  description: {
    whiteSpace: 'pre-wrap',
  },
});

const CardAccordion = ({
  className,
  classes,
  HeaderContent,
  BodyContent,
  test,
}) => {
  return (
    <Accordion
      className={classNames(classes.root, className)}
      classes={{
        root: classes.accordion,
        rounded: classes.roundedAccordion,
      }}
      elevation={0}
      square
      test={test}
    >
      <AccordionSummary
        aria-controls={'balance-sheet-item-summary'}
        className={classes.header}
        test={`${test}-summary`}
      >
        <Header content={HeaderContent} />
      </AccordionSummary>
      <AccordionDetails
        className={classes.accountDetails}
        test={`${test}-details`}
      >
        <Body
          className={classes.body}
          content={BodyContent}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CardAccordion.defaultProps = {
  className: '',
  test: 'card-accordion',
};

CardAccordion.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  HeaderContent: PropTypes.func.isRequired,
  BodyContent: PropTypes.node.isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(CardAccordion);
